var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#27B0D4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.974 4.735h-7.185l-.355-2.14a1.725 1.725 0 0 0-1.697-1.4h-9.355c-.83 0-1.54.583-1.658 1.4l-.356 2.14H4.026a.97.97 0 0 0-.987.973.97.97 0 0 0 .987.973h2.132l1.697 25.174c.08 1.361 1.303 2.412 2.724 2.412H25.42c1.46 0 2.645-1.05 2.724-2.412L29.842 6.68h2.132a.97.97 0 0 0 .987-.973.97.97 0 0 0-.987-.973zM13.658 3.14H22.5l.276 1.595h-9.394l.276-1.595zM26.17 31.738c-.04.311-.355.584-.79.584H10.58c-.395 0-.75-.273-.79-.584L8.132 6.72h19.736l-1.697 25.018z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.079 29.209c.434 0 .79-.35.79-.778V10.533a.786.786 0 0 0-.79-.779c-.434 0-.79.35-.79.779V28.43c0 .428.356.778.79.778zM22.382 29.209c.473 0 .79-.311.829-.74L24 10.573a.813.813 0 0 0-.75-.818.816.816 0 0 0-.829.74l-.79 17.898a.762.762 0 0 0 .75.817zM13.737 29.209c.474 0 .79-.39.79-.817l-.79-17.898c0-.428-.395-.778-.83-.74-.433 0-.789.39-.75.818l.79 17.898c0 .428.356.739.79.739z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.f18bf9be3a730d206ea8491a9cde9f91.svg";
export { ForwardRef as ReactComponent };